import { Component, OnInit, Input } from '@angular/core'
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Subject } from 'rxjs/Subject';

@Component({
    selector: 'col-estabelecimento-modal-confirmacao',
    templateUrl: './estabelecimento-modal-confirmacao.component.html',
})

export class EstabelecimentoModalConfirmacaoComponent implements OnInit {
    @Input() titulo: String;
    @Input() modalContent: String;

    public onClose: Subject<boolean>;

    inputValue: String;
    podeConfirmar: Boolean;
    carregando: Boolean = false;

    constructor(private bsModalRef: BsModalRef) {}

    ngOnInit() {
        this.onClose = new Subject();
        this.inputValue = "";
        this.podeConfirmar = false;
    }

    onConfirmar() {
        this.onClose.next(true);
    }

    onCancelar() {
        this.bsModalRef.hide();
        this.onClose.next(false);
    }

    onInputChange(event) {
        event.target.value = event.target.value.toUpperCase();
        this.podeConfirmar = event.target.value === "ENTENDI";
    }
}


// WEBPACK FOOTER //
// ./src/app/estabelecimentos/estabelecimento-modal-confirmacao/estabelecimento-modal-confirmacao.component.ts